import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { isLoadingSelector } from 'src/store/selectors/statusSelector';
import { CREATE_CONTRACT_FROM_QUOTE } from 'src/store/actions/contractActions';
import StepOne from './StepOne';
import StepEquipment from './StepEquipment';
import StepTwo from './StepTwo';
import StepThree from './StepThree';
import StepFour from './StepFour';
import StepFive from './StepFive';
import FinalStep from './FinalStep';

const CurrentStep = ({
  activeStep,
  data,
  includeEquipmentStep,
  onNext,
  onBack,
  onSubmit,
  open,
  resetRef,
  clientAddress,
  isQuoteAssignedToClient
}) => {
  const loading = useSelector(
    isLoadingSelector([CREATE_CONTRACT_FROM_QUOTE.action])
  );
  const quoteStep = 0;
  const clientStep = 1;
  const equipmentStep = 2;
  const avalsStep = includeEquipmentStep ? 3 : 2;
  const addressStep = includeEquipmentStep ? 4 : 3;
  const paymentMethodStep = includeEquipmentStep ? 5 : 4;

  if (activeStep === quoteStep) {
    return (
      <StepOne
        data={data}
        handleNext={onNext}
        handleBack={onBack}
        open={open}
        resetRef={resetRef}
      />
    );
  }

  if (activeStep === clientStep) {
    return (
      <StepTwo
        data={data}
        open={open}
        isQuoteAssignedToClient={isQuoteAssignedToClient}
        handleNext={onNext}
        handleBack={onBack}
        resetRef={resetRef}
        existingAddress={clientAddress}
      />
    );
  }

  if (includeEquipmentStep && activeStep === equipmentStep) {
    const isMultiEquipment = data.equipmentsList?.length > 1;
    const isHidden = data.equipment?.isHidden ?? false;
    return (
      <StepEquipment
        data={data}
        handleNext={onNext}
        handleBack={onBack}
        resetRef={resetRef}
        isEditable={isHidden}
        equipmentsList={data.equipmentsList || []}
        isMultiEquipment={isMultiEquipment}
      />
    );
  }

  if (activeStep === avalsStep) {
    return (
      <StepThree
        data={data}
        open={open}
        handleNext={onNext}
        handleBack={onBack}
        resetRef={resetRef}
        existingAddress={clientAddress}
      />
    );
  }
  if (activeStep === addressStep) {
    return (
      <StepFour
        data={data}
        handleNext={onNext}
        handleBack={onBack}
        resetRef={resetRef}
        existingAddress={clientAddress}
      />
    );
  }

  if (activeStep === paymentMethodStep) {
    return (
      <StepFive
        data={data}
        handleNext={onNext}
        handleBack={onBack}
        resetRef={resetRef}
      />
    );
  }

  return (
    <FinalStep
      data={data}
      includeEquipmentStep={includeEquipmentStep}
      loading={loading}
      handleBack={onBack}
      handleSubmit={onSubmit}
    />
  );
};

CurrentStep.propTypes = {
  activeStep: PropTypes.number.isRequired,
  open: PropTypes.bool.isRequired,
  data: PropTypes.any.isRequired,
  includeEquipmentStep: PropTypes.bool,
  onNext: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  resetRef: PropTypes.object.isRequired,
  clientAddress: PropTypes.object,
  isQuoteAssignedToClient: PropTypes.bool
};

CurrentStep.defaultProps = {
  includeEquipmentStep: false
};

export default CurrentStep;
